import React from 'react';
import { Link } from "react-router-dom";
import Auth from "../../services/Auth.service";
import { useTranslation } from "react-i18next";
import OrdersListComponents from "../../components/OrdersComponents/OrdersListComponents";
export default function OrdersOrderNavigation() {

    const { t } = useTranslation();

    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="col-12 col-lg-11 mx-auto">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/OrdersOrderNavigation/'}>{t("Global_Label_Text_Orders")}</Link></li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
                <div>
                    <OrdersListComponents />
                </div>
                <br />
            </div > : ""}
        </div>
    );

}
